import script from "./VerificationInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationInput.vue?vue&type=script&setup=true&lang=js"

import "./VerificationInput.vue?vue&type=style&index=0&id=30e3ccea&lang=scss"

const __exports__ = script;

export default __exports__